var map = {
	"./classic/black_bishop_classic.svg": 9275,
	"./classic/black_king_classic.svg": 3333,
	"./classic/black_knight_classic.svg": 4213,
	"./classic/black_pawn_classic.svg": 6195,
	"./classic/black_queen_classic.svg": 5928,
	"./classic/black_rook_classic.svg": 1193,
	"./classic/black_tile_classic.svg": 743,
	"./classic/white_bishop_classic.svg": 4215,
	"./classic/white_king_classic.svg": 3587,
	"./classic/white_knight_classic.svg": 8157,
	"./classic/white_pawn_classic.svg": 1211,
	"./classic/white_queen_classic.svg": 4337,
	"./classic/white_rook_classic.svg": 9897,
	"./classic/white_tile_classic.svg": 143,
	"./default/black_bishop_default.svg": 8415,
	"./default/black_king_default.svg": 5529,
	"./default/black_king_default_back.svg": 163,
	"./default/black_knight_default.svg": 5171,
	"./default/black_pawn_default.svg": 1504,
	"./default/black_pawn_default_back.svg": 1425,
	"./default/black_queen_default.svg": 7255,
	"./default/black_rook_default.svg": 8347,
	"./default/black_tile_default.svg": 7139,
	"./default/white_bishop_default.svg": 7966,
	"./default/white_king_default.svg": 6114,
	"./default/white_king_default_back.svg": 1033,
	"./default/white_knight_default.svg": 3414,
	"./default/white_pawn_default.svg": 2207,
	"./default/white_pawn_default_back.svg": 4859,
	"./default/white_queen_default.svg": 4684,
	"./default/white_rook_default.svg": 3609,
	"./default/white_tile_default.svg": 1295,
	"./law/black_bishop_law.svg": 1367,
	"./law/black_bishop_law_back.svg": 2306,
	"./law/black_king_law.svg": 4688,
	"./law/black_king_law_back.svg": 2564,
	"./law/black_knight_law.svg": 4325,
	"./law/black_pawn_law.svg": 1449,
	"./law/black_pawn_law_back.svg": 44,
	"./law/black_queen_law.svg": 9152,
	"./law/black_queen_law_back.svg": 2963,
	"./law/black_rook_law.svg": 8433,
	"./law/black_rook_law_back.svg": 6131,
	"./law/white_bishop_law.svg": 4374,
	"./law/white_bishop_law_back.svg": 8285,
	"./law/white_king_law.svg": 7415,
	"./law/white_king_law_back.svg": 7353,
	"./law/white_knight_law.svg": 8596,
	"./law/white_pawn_law.svg": 6060,
	"./law/white_pawn_law_back.svg": 8730,
	"./law/white_queen_law.svg": 5932,
	"./law/white_queen_law_back.svg": 752,
	"./law/white_rook_law.svg": 1113,
	"./law/white_rook_law_back.svg": 6426,
	"./law_prestige/black_bishop_law_prestige.svg": 6795,
	"./law_prestige/black_bishop_law_prestige_back.svg": 7689,
	"./law_prestige/black_king_law_prestige.svg": 3661,
	"./law_prestige/black_king_law_prestige_back.svg": 4091,
	"./law_prestige/black_knight_law_prestige.svg": 4448,
	"./law_prestige/black_pawn_law_prestige.svg": 5893,
	"./law_prestige/black_pawn_law_prestige_back.svg": 4631,
	"./law_prestige/black_queen_law_prestige.svg": 4560,
	"./law_prestige/black_queen_law_prestige_back.svg": 8367,
	"./law_prestige/black_rook_law_prestige.svg": 4805,
	"./law_prestige/black_rook_law_prestige_back.svg": 4977,
	"./law_prestige/white_bishop_law_prestige.svg": 7328,
	"./law_prestige/white_bishop_law_prestige_back.svg": 3105,
	"./law_prestige/white_king_law_prestige.svg": 1588,
	"./law_prestige/white_king_law_prestige_back.svg": 8959,
	"./law_prestige/white_knight_law_prestige.svg": 9227,
	"./law_prestige/white_pawn_law_prestige.svg": 4254,
	"./law_prestige/white_pawn_law_prestige_back.svg": 6187,
	"./law_prestige/white_queen_law_prestige.svg": 6952,
	"./law_prestige/white_queen_law_prestige_back.svg": 7714,
	"./law_prestige/white_rook_law_prestige.svg": 3635,
	"./law_prestige/white_rook_law_prestige_back.svg": 2184,
	"./mafia/black_bishop_mafia.svg": 2936,
	"./mafia/black_bishop_mafia_back.svg": 1497,
	"./mafia/black_king_mafia.svg": 9273,
	"./mafia/black_king_mafia_back.svg": 5782,
	"./mafia/black_knight_mafia.svg": 9726,
	"./mafia/black_pawn_mafia.svg": 7550,
	"./mafia/black_pawn_mafia_back.svg": 1629,
	"./mafia/black_queen_mafia.svg": 6263,
	"./mafia/black_queen_mafia_back.svg": 4993,
	"./mafia/black_rook_mafia.svg": 6327,
	"./mafia/black_rook_mafia_back.svg": 2770,
	"./mafia/black_tile_mafia.svg": 6579,
	"./mafia/white_bishop_mafia.svg": 1215,
	"./mafia/white_bishop_mafia_back.svg": 1686,
	"./mafia/white_king_mafia.svg": 3700,
	"./mafia/white_king_mafia_back.svg": 7624,
	"./mafia/white_knight_mafia.svg": 1134,
	"./mafia/white_pawn_mafia.svg": 949,
	"./mafia/white_pawn_mafia_back.svg": 8656,
	"./mafia/white_queen_mafia.svg": 8856,
	"./mafia/white_queen_mafia_back.svg": 975,
	"./mafia/white_rook_mafia.svg": 6010,
	"./mafia/white_rook_mafia_back.svg": 9580,
	"./mafia/white_tile_mafia.svg": 7210,
	"./mafia_rouge/black_bishop_mafia_rouge.svg": 5530,
	"./mafia_rouge/black_bishop_mafia_rouge_back.svg": 3796,
	"./mafia_rouge/black_king_mafia_rouge.svg": 2705,
	"./mafia_rouge/black_king_mafia_rouge_back.svg": 1928,
	"./mafia_rouge/black_knight_mafia_rouge.svg": 3563,
	"./mafia_rouge/black_pawn_mafia_rouge.svg": 5396,
	"./mafia_rouge/black_pawn_mafia_rouge_back.svg": 5406,
	"./mafia_rouge/black_queen_mafia_rouge.svg": 1743,
	"./mafia_rouge/black_queen_mafia_rouge_back.svg": 6066,
	"./mafia_rouge/black_rook_mafia_rouge.svg": 350,
	"./mafia_rouge/black_rook_mafia_rouge_back.svg": 3437,
	"./mafia_rouge/white_bishop_mafia_rouge.svg": 3560,
	"./mafia_rouge/white_bishop_mafia_rouge_back.svg": 5203,
	"./mafia_rouge/white_king_mafia_rouge.svg": 4012,
	"./mafia_rouge/white_king_mafia_rouge_back.svg": 5153,
	"./mafia_rouge/white_knight_mafia_rouge.svg": 1177,
	"./mafia_rouge/white_pawn_mafia_rouge.svg": 1936,
	"./mafia_rouge/white_pawn_mafia_rouge_back.svg": 2302,
	"./mafia_rouge/white_queen_mafia_rouge.svg": 104,
	"./mafia_rouge/white_queen_mafia_rouge_back.svg": 3659,
	"./mafia_rouge/white_rook_mafia_rouge.svg": 6355,
	"./mafia_rouge/white_rook_mafia_rouge_back.svg": 1539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3863;